import React from "react"
import {Custom} from "../Custom";
import {HttpService} from "../../service/HttpService";
import {SubscriptionDetails} from "./SubscriptionDetails";

export const SubscriptionDetailsPage = () => {
  const customProject = HttpService?.customProject;

  return (<>
    {
      customProject?.customFrontend && customProject?.frontendComponents?.some(component => component?.pathUrl === "/subscription-details-custom")
          ? (
              <Custom
                  customFrontendUrl={customProject?.customFrontendUrl}
                  type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === "/subscription-details-custom")?.component}
              />
          ) : <SubscriptionDetails />
    }
  </>)
}
